// extracted by mini-css-extract-plugin
module.exports = {"main":"Timer_main__2hXMc","img":"Timer_img__ztooS","time":"Timer_time__lqpVu","fade":"Timer_fade__XZWFH","text":"Timer_text__265u_"};